import api from './api';

export interface VarianceOverride {
  kpi: string;
  period: string;
  internal_value: number;
}

/** Fired after any override write so sibling widgets (e.g. the Consensus
 *  Revision chart's "Your Estimate" overlay) can refresh without a reload. */
export const VARIANCE_OVERRIDES_CHANGED = 'variance-overrides-changed';

export const varianceOverrideService = {
  list: async (ticker: string): Promise<VarianceOverride[]> => {
    const res = await api.get<VarianceOverride[]>('/variance-overrides', { params: { ticker } });
    return res.data;
  },
  // value === null clears the override (revert to the model's number).
  upsert: async (ticker: string, kpi: string, period: string, value: number | null): Promise<void> => {
    await api.put('/variance-overrides', { ticker, kpi, period, internal_value: value });
    window.dispatchEvent(new CustomEvent(VARIANCE_OVERRIDES_CHANGED, { detail: { ticker } }));
  },
};
